import { Trans } from '@lingui/react'
import { arrayOf, func, oneOfType, shape, string } from 'prop-types'
import { PureComponent } from 'react'
import { connectMenu } from 'react-instantsearch-dom'

import {
  PRODUCT_FILTER_RESET,
  PRODUCT_FILTER_RESET_SFX,
} from 'shared/experiments/components/NewSerp/consts'
import { withSearchStateHandler } from 'shared/experiments/components/NewSerp/helpers'
import { CategoryListItemType } from 'shared/experiments/components/NewSerp/types'
import store, { subscribe } from 'shared/store'
import { hideModalAction } from 'shared/store/ducks/events'
import Button from 'views/components/atoms/Button'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'
import { publicRuntimeConfigType } from 'views/utils/propTypes'

import CategoryListItem from './CategoryListItem'
import { parseCategories } from './helpers'

import './CategoryListV1.scss'

class CategoryListMobileV1 extends PureComponent {
  subscriptions = []
  state = {
    currentCategory: this.props.currentRefinement,
  }

  constructor(props) {
    super(props)

    this.subscriptions.push(
      subscribe.after(PRODUCT_FILTER_RESET, this.handleResetClick)
    )

    this.subscriptions.push(
      subscribe.after(
        `${PRODUCT_FILTER_RESET_SFX}${this.props.attribute}`,
        this.handleResetClick
      )
    )
  }

  componentWillUnmount() {
    this.subscriptions.forEach(unsub => unsub())
  }

  handleResetClick = () => {
    this.setState({ currentCategory: '' }, () => {
      withSearchStateHandler(() => this.props.refine(''))
    })
  }

  handleCategoryListItemClick = ({ value }) => {
    this.setState(state => ({
      currentCategory: value === state.currentCategory ? '' : value,
    }))
  }

  handleApplyCategoryFilter = () => {
    this.props.refine(this.state.currentCategory)
    store.dispatch(hideModalAction(this.props.modalId))
  }

  render() {
    const { items, label, currentRefinement } = this.props
    const { currentCategory } = this.state
    const parsedItems = parseCategories({
      items,
      currentCategory,
    })

    const isModified = currentRefinement || currentCategory

    return (
      <div className="e-CategoryListMobile-v1">
        <div className="u-font-weight--semi-bold u-margin-small--bottom">
          {label}
        </div>
        <div>
          <ul className="e-RefinementList e-RefinementList--horizontalScroll m-CategoryList a-list-reset u-padding--right">
            {parsedItems.map((item, index) => (
              <CategoryListItem
                key={item.value}
                isLast={index + 1 === parsedItems.length}
                onClick={() => this.handleCategoryListItemClick(item)}
                item={{ ...item, isRefined: item.value === currentCategory }}
              />
            ))}
          </ul>

          <div className="u-margin--top u-padding--top e-RefinementList__CategoryList__resetButton--wrapper">
            <Button
              onClick={this.handleApplyCategoryFilter}
              name={`category-list-confirm-selection-${this.props.attribute}`}
              className="e-CategoryListMobile-v1__cta"
              isClientsideControlled
            >
              {isModified ? (
                <Trans id="general.label.link.apply" />
              ) : (
                <Trans id="general.link.label.back" />
              )}
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

CategoryListMobileV1.propTypes = {
  publicRuntimeConfig: shape(publicRuntimeConfigType).isRequired,
  label: string.isRequired,
  attribute: string.isRequired,
  items: arrayOf(CategoryListItemType).isRequired,
  refine: func.isRequired,
  currentRefinement: oneOfType([string, shape({})]),
  modalId: string,
}

CategoryListMobileV1.defaultProps = {
  currentRefinement: null,
}

export default connectMenu(withShopAndRuntimeConfig(CategoryListMobileV1))
